import api from './api';

const API_URL = '/transporteur/remorques';

export const getRemorques = async (transporteurId) => {
    try {
        const response = await api.get(API_URL, {
            params: { transporteurId }
        });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to fetch trailers');
    }
};

export const getRemorque = async (id) => {
    try {
        const response = await api.get(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            throw new Error('Trailer not found');
        } else {
            throw new Error(error.response?.data?.message || 'Failed to fetch trailer');
        }
    }
};

export const createRemorque = async (remorqueData) => {
    try {
        const response = await api.post(API_URL, remorqueData);
        return response.data;
    } catch (error) {
        if (error.response?.status === 400) {
            throw new Error(error.response.data.message || 'Invalid trailer data');
        } else {
            throw new Error(error.response?.data?.message || 'Failed to create trailer');
        }
    }
};

export const updateRemorque = async (id, remorqueData) => {
    try {
        const response = await api.put(`${API_URL}/${id}`, remorqueData);
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            throw new Error('Trailer not found');
        } else if (error.response?.status === 400) {
            throw new Error(error.response.data.message || 'Invalid trailer data');
        } else {
            throw new Error(error.response?.data?.message || 'Failed to update trailer');
        }
    }
};

export const deleteRemorque = async (id) => {
    try {
        const response = await api.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            throw new Error('Trailer not found');
        } else {
            throw new Error(error.response?.data?.message || 'Failed to delete trailer');
        }
    }
};

export const updateRemorqueStatus = async (id, status) => {
    try {
        const response = await api.put(`${API_URL}/${id}/status`, null, { params: { status } });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.response?.data?.message || 'Failed to update trailer status');
    }
};

export const checkRemorqueAvailability = async (id) => {
    try {
        const response = await api.get(`${API_URL}/${id}/availability-check`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'Failed to check trailer availability');
    }
};

const remorqueService = {
    getRemorques,
    getRemorque,
    createRemorque,
    updateRemorque,
    deleteRemorque,
    updateRemorqueStatus,
    checkRemorqueAvailability,
};

export default remorqueService;
